<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'shared.modals.confirmation.title' | translate }}
    </h5>
  </div>
  <div class="modal-body" *ngIf="text">
    <span>
      {{ text }}
    </span>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" ngbAutofocus type="button" (click)="onCloseModal()">
      {{ 'shared.modals.confirmation.buttons.cancel' | translate }}
    </button>
    <button class="btn btn-danger" type="button" (click)="onConfirm()">
      {{ 'shared.modals.confirmation.buttons.yes' | translate }}
    </button>
  </div>
</div>
